import { useContext } from 'react'
import { PermissionDto } from 'api/Identity/Types/PermissionDto'
import { PermissionsEnum } from 'api/Identity/Types/PermissionsEnum'

import { AuthSessionContext } from './AuthContext'

export const usePermissions = () => {
  const [auth] = useContext(AuthSessionContext)
  const permissions = auth?.permissions || []

  return {
    hasPermission: (permissionType: PermissionsEnum) => hasPermission(permissions, permissionType),
  }
}

export function hasPermission(
  permissions: PermissionDto[] = [],
  permissionIdentifier?: number
): boolean {
  if (!permissionIdentifier) return true

  const permissionExist = (permissions || []).find((x) => x.id === permissionIdentifier)
  return !!permissionExist
}

export function hasSomePermissions(
  permissions: PermissionDto[],
  permissionIdentifier?: number[]
): boolean {
  if (!permissionIdentifier) return true

  const permissionExist = (permissions || []).find((x) => permissionIdentifier.includes(x.id))
  return !!permissionExist
}

export function hasAllPermissions(
  permissions: PermissionDto[],
  permissionIdentifier?: number[]
): boolean {
  if (!permissionIdentifier) return true

  const permissionExist = permissionIdentifier.every((x) =>
    permissions.map((p) => p.id).includes(x)
  )
  return !!permissionExist
}
